import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations'
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginComponent } from './login/login.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { KnowledgeHubComponent } from './knowledge-hub/knowledge-hub.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { HeaderComponent } from './header/header.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { GetAnswerComponent } from './get-answer/get-answer.component';
import { AuthInterceptor } from './auth.interceptor';
import { DialogModule } from 'primeng/dialog';
import { TableModule } from 'primeng/table';
import { KhDocComponent } from './kh-doc/kh-doc.component';
import { ToastModule } from 'primeng/toast';
import { ConfirmationService, MessageService } from 'primeng/api';
import { SavedAnswerComponent } from './saved-answer/saved-answer.component';
import { HistoryComponent } from './history/history.component';
import { TrendingQuesionsComponent } from './trending-quesions/trending-quesions.component';
import { CardModule } from 'primeng/card';
import { DropdownModule } from 'primeng/dropdown';
import { RedashDashboardComponent } from './redash-dashboard/redash-dashboard.component';
import { PaginatorModule } from 'primeng/paginator';
import { NgSelectModule } from '@ng-select/ng-select';
import { ClipboardModule } from '@angular/cdk/clipboard'
import { TaskWorkComponent } from './task-work/task-work.component';
import { QuestionAnswerComponent } from './question-answer/question-answer.component';
import { FaqDetailComponent } from './faq-detail/faq-detail.component';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { HighlightPipe } from './highlight.pipe';
import { CalendarModule } from 'primeng/calendar';
import { DatePipe } from './date.pipe';
import { LMarkdownEditorModule } from 'ngx-markdown-editor';
import { TooltipModule } from 'primeng/tooltip';
import { KhDocPageComponent } from './kh-doc-page/kh-doc-page.component';
import { FileUploadModalComponent } from './file-upload-modal/file-upload-modal.component';
import { MultiSelectModule } from 'primeng/multiselect';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { AccordionModule } from 'primeng/accordion';
import { PanelModule } from 'primeng/panel';
import { CodemirrorModule } from '@ctrl/ngx-codemirror';
import { DatainsightComponent } from './datainsight/datainsght.component';
import { NgChartsModule } from 'ng2-charts';
import { HighlightDirective } from './highlight.directive';
import { HomeComponent } from './home/home.component';
@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    HomeComponent,
    KnowledgeHubComponent,
    DashboardComponent,
    HeaderComponent,
    SidebarComponent,
    GetAnswerComponent,
    KhDocComponent,
    SavedAnswerComponent,
    TrendingQuesionsComponent,
    HistoryComponent,
    RedashDashboardComponent,
    TaskWorkComponent,
    QuestionAnswerComponent,
    FaqDetailComponent,
    HighlightPipe,
    DatePipe,
    KhDocPageComponent,
    FileUploadModalComponent,
    DatainsightComponent,
    HighlightDirective
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    FormsModule,
    HttpClientModule,
    DialogModule,
    TableModule,
    ToastModule,
    CardModule,
    DropdownModule,
    PaginatorModule,
    NgSelectModule,
    ReactiveFormsModule,
    ClipboardModule,
    AutoCompleteModule,
    CalendarModule,
    LMarkdownEditorModule,
    TooltipModule,
    MultiSelectModule,
    ConfirmDialogModule,
    AccordionModule,
    PanelModule,
    CodemirrorModule,
    CalendarModule,
    NgChartsModule
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    MessageService,
    ConfirmationService
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
